// extracted by mini-css-extract-plugin
export default {"intro":"ComunicadosModal_intro__r6tV5 ui_introModal__ciHkf ui_textoSuave13__ecp81"};